export default __webpack_public_path__ + "static/media/kia.23cac6dc.png";